import React from 'react';
import { Tooltip } from 'antd';
import useTranslation from '../../hooks/translation/useTranslation';

function WagonDoor({ className = '' }) {
  const { trans } = useTranslation();
  return (
    <div className={`wagon-feature ${className}`}>
      <Tooltip title={trans('wagon_exit')}>
        <img src="/wagon-icons/exit.png" width={46} height={46} className="object-center" alt="exit" />
      </Tooltip>
    </div>
  );
}

export default WagonDoor;
